export default "__VITE_ASSET__CAAdTr4R__"